import { useMemo } from 'react';

import { TokenFormatter, NameAndCreateDateWithUserFormatter, PermissionsFormatter } from '@Components/Grid/components/Table/formatters'
import column, { defaultActiveColumn } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    column.accessor('id', {
      header: 'Token',
      cell: info => <TokenFormatter info={info} disabledTooltip={'You can copy token only the creation event.'} />,
      enableSorting: false,
      maxSize: 100,
    }),
    column.accessor('description', {
      header: 'Description',
      cell: info => <NameAndCreateDateWithUserFormatter info={info} link={false} />,
    }),
    column.accessor('meta.permissions', {
      header: 'Permissions',
      cell: info => <PermissionsFormatter info={info} />,
      enableSorting: false,
    }),
    defaultActiveColumn(),
  ], [])
}
